module.exports = __webpack_public_path__ + "static/media/8.006abc38.jpg";